<template>
  <div class="modal-overlay">
    <div class="modal-content" style="max-width: 35vw">
      <div class="modal-header">
        <h5 class="modal-title">➕ Add New Role</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label>Role Name:</label>
          <input type="text" v-model="roleName" placeholder="Enter role name" />
        </div>

        <!-- <div class="form-group">
          <label>Role Description:</label>
          <textarea
            v-model="roleDescription"
            placeholder="Describe this role"
          ></textarea>
        </div> -->
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn btn-save" @click="saveModal">
          Save Role
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "AddRoleModal",
  data() {
    return {
      roleName: "",
      roleDescription: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-add-role-modal");
    },
    async saveModal() {
      if (!this.roleName.trim()) {
        alert("Role name is required.");
        return;
      }
      const url = "roles/store";
      const body = { name: this.roleName };

      const rs = await generalApiRequest(url, "POST", body, 1);
      console.log(rs);

      //
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 0.4rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.modal-title {
  font-size: 1.2rem;
}

.close {
  background: #e31919;
  color: #fff;
  border: none;
  font-size: 1.3rem;
  line-height: 1;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
}

.modal-body {
  padding: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.4rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #bbb;
  border-radius: 0.3rem;
  font-size: 0.95rem;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.8rem 1rem;
  border-top: 1px solid #ddd;
}

.btn-save {
  background: #2786f7;
  color: #fff;
  padding: 0.45rem 1rem;
  border: none;
  border-radius: 0.3rem;
  margin-left: 0.5rem;
  cursor: pointer;
}

.btn-cancel {
  background: #aaa;
  color: #fff;
  padding: 0.45rem 1rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
}
</style>
